import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';
import { MeetingTimerComponent } from './meeting-timer/meeting-timer.component';







@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild()
  ],
  declarations: [
    LanguageSwitcherComponent,
    MeetingTimerComponent,

  ],
  exports: [
    LanguageSwitcherComponent,
    MeetingTimerComponent,

  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
